/* Stage 2 "Dashboard" · 2.2 / C-14 — "Engagement-level documents" section of the Documents page. The engagement-level
   AttachmentPanel moved here from the Engagements tab: same contextType "engagement" and context id (the engagement id), so
   every existing upload shows; the /attachments routes are unchanged. Read-only once the engagement is signed off. */
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import AttachmentPanel from "@/components/AttachmentPanel";
import { useI18n } from "@/contexts/I18nContext";

export default function EngagementDocsSection({ engagement }) {
  const { t } = useI18n();
  if (!engagement?.id) return null;
  return (
    <Card data-testid="eng-docs-section">
      <CardHeader>
        <CardTitle className="text-base">{t("dsD.engDocsTitle")}</CardTitle>
        <p className="text-xs text-muted-foreground">{t("dsD.engDocsHint")}</p>
      </CardHeader>
      <CardContent>
        <AttachmentPanel engagementId={engagement.id}
                         contextType="engagement" contextId={engagement.id}
                         locked={!!engagement.signed_off}
                         label={t("engagements.supportDocsLabel")} />
      </CardContent>
    </Card>
  );
}
